import React, { Component } from 'react';

import Core from '../../../Core/Core';
import Header from '../../Header';
import Alerts from '../../Alert/Alerts';

import logo_convert from './../../../Static/logo-convert.png';
import background_convert from './../../../Static/background-convert.jpg';

import ErrorBoundary from '../ErrorBoundary';
import ErrorManager from './../../../Core/ErrorManager';

class Convert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paths: [],
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    document.title = 'W-F: Scan';
    if (Core.Instance.user && Core.Instance.user.id) {
      let request = Core.Address + 'Logs_maeva/User_id/' + Core.Instance.user.id;
      Core.Instance.Request(request, null, 'GET').then((json) => {
        if (json) {
          let now = new Date().getTime() / 1000 - 15;
          let paths = Array.isArray(json) ? json : [];
          paths = json.filter((item) => item.date > now);
          paths = paths.map((item) => {
            if (item.file.includes('Generated_from_url')) {
              return { name: 'Conversion effectuée', href: item.file };
            }
            return { name: item.file, href: item.file };
          });
          this.setState({
            paths: json != null ? paths : [],
          });
        }
      }).catch((error) => {
        ErrorManager.Instance.Handle(error);
      });
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    const files = document.querySelector('[type=file]').files;
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      let file = files[i];
      formData.append('files[]', file);
    }
    let request = Core.Address + 'Convert';
    Core.Instance.Request(request, formData, 'POST').then((json) => {
      this.setState({
        paths: json != null ? json : [],
      });
    });
  }

  render() {
    const { paths } = this.state;
    let user = JSON.parse(localStorage.getItem('User'));

    let user_id = user && user.id ? user.id : '';
    return (
      <ErrorBoundary>
        <div className='Convert' style={{ backgroundImage: `url(${background_convert})` }}>
          <div className='Content'>
            <img src={logo_convert} />
            <form encType='multipart/form-data' acceptCharset='UTF-8' className='rounded p-5 text-center'>
              <h1 className='text-white'>Conversion HTML vers XML</h1>
              <div className='form-group mt-5 mb-5'>
                <h2 className='text-left text-white'>Fichiers à convertir</h2>
                <input
                  id='files'
                  className='form-control h-auto'
                  type='file'
                  name='files[]'
                  multiple
                  accept='.htm, .html, .txt'
                  style={{ overflow: 'hidden' }}
                />
                <small className='form-text'>Vous pouvez sélectionner autant de fichiers que vous le souhaitez.</small>
              </div>
              <small className='form-text'>
                Vous pouvez aussi directement demander la conversion d'un document en glissant-déposant ce lien dans votre barre de marque page puis
                en cliquant dessus au besoin lors de la consultation d'un document à convertir:
                <br />
                <a
                  href={
                    'javascript:(function(){var%20data=btoa(unescape(encodeURIComponent("<html>"+window.document.childNodes[1].innerHTML+"</html>")));var%20form=document.createElement("form");form.setAttribute("method","POST");form.setAttribute("action","https://www.weeflow-figest.ovh/convert/index.php");var%20hiddenField=document.createElement("input");hiddenField.setAttribute("type","hidden");hiddenField.setAttribute("name","html");hiddenField.setAttribute("value",data);form.appendChild(hiddenField);document.body.appendChild(form);form.submit();})();'
                  }
                  className='text-primary'
                >
                  Conversion XML (IE)
                </a>
                <br />
                <a
                  href={
                    'javascript:(function(){var%20data=btoa(unescape(encodeURIComponent("<html>"+window.document.children[0].innerHTML+"</html>")));var%20form=document.createElement("form");form.setAttribute("method","POST");form.setAttribute("action","https://www.weeflow-figest.ovh/convert/index.php");var%20hiddenField=document.createElement("input");hiddenField.setAttribute("type","hidden");hiddenField.setAttribute("name","html");hiddenField.setAttribute("value",data);form.appendChild(hiddenField);var%20hiddenUser=document.createElement("input");hiddenUser.setAttribute("type","hidden");hiddenUser.setAttribute("name","user");hiddenUser.setAttribute("value","' +
                    user_id +
                    '");form.appendChild(hiddenUser);document.body.appendChild(form);form.submit();})();'
                  }
                  className='text-primary'
                >
                  Conversion XML (chrome/firefox)
                </a>
              </small>
              <br />
              <button type='button' className='btn btn-primary' onClick={(e) => this.handleSubmit(e)}>
                Convertir
              </button>
              <br />
              <br />
              {paths != null && paths.length > 0 && (
                <div>
                  <h2 className='text-left text-white'>Résultats</h2>
                  <ul className='list-group pl-0'>
                    {paths.map((path, index) => {
                      return (
                        <li className='list-group-item' key={index}>
                          <a className='text-blue' href={path['href']}>
                            {path['name']}
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
            </form>
          </div>
        </div>
      </ErrorBoundary>
    );
  }
}

export default Convert;



// WEBPACK FOOTER //
// ./src/Components/Views/Convert/Convert.js